module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460951.6ab08056.png";